import callApi from '../../util/apiCaller';
import eventCallApi from '../../util/apiEventCaller';
import {userNotify} from '../../modules/components/Toasts/ToastAdd';
import async from 'async';
import isEmpty from 'lodash/isEmpty';

import {removeEventIdFromStorage, saveEventIdToStorage} from '../../util/vmStorageHandler';
import {
    checkIfIsSayaDate,
    showShortlistingVenuePageLoader,
    showShortlistingVenueSearchPageLoader,
} from '../actions/VenueActions';
import {setEventRedirectionUrl,} from './LeadActions';
import {makeRedirectionUrl} from '../../util/leadFormUtility';
import {sendFirstVerificationSms, verifyOTPCode} from './EventVerificationActions';
import venueCallApi from '../../util/apiVenueCaller';
import moment from 'moment';
import callIdApi from '../../util/idApiCaller';

// list page
export const AGENT_DETAILS = 'AGENT_DETAILS';
export const FETCH_EVENTS_FOR_PAGE = 'FETCH_EVENTS_FOR_PAGE';
export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS';
export const FETCH_EVENTS_FAILURE = 'FETCH_EVENT_FAILURE';

// bookings page
export const FETCH_BOOKINGS_FOR_PAGE = 'FETCH_BOOKINGS_FOR_PAGE';
export const FETCH_BOOKING_SUCCESS = 'FETCH_BOOKING_SUCCESS';
export const FETCH_BOOKING_FAILURE = 'FETCH_BOOKING_FAILURE';

//customer dashboard common
export const FETCH_AGENT_DETAILS = 'FETCH_AGENT_DETAILS';
export const FETCHING_EVENT = 'FETCHING_EVENT';
export const FETCH_EVENT = 'FETCH_EVENT';
export const UPDATING_EVENT = 'UPDATING_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const FETCHING_BUNDLE = 'FETCHING_BUNDLE';
export const FETCH_BUNDLE = 'FETCH_BUNDLE';

// details page
export const FETCH_BASE_PARAMS = 'FETCH_BASE_PARAMS';
export const UPDATE_BASE_PARAMS_STATE = 'UPDATE_BASE_PARAMS_STATE';
export const UPDATE_LOCATION_PARAMS_STATE = 'UPDATE_LOCATION_PARAMS_STATE';
export const FETCH_LOCATION_PARAMS = 'FETCH_LOCATION_PARAMS';
export const UPDATE_RECO_COUNT = 'UPDATE_RECO_COUNT';

// recommended page
export const FETCH_RECOMMENDED_VENUESV1 = 'FETCH_RECOMMENDED_VENUESV1';
export const FETCH_RECOMMENDED_VENUESV2 = 'FETCH_RECOMMENDED_VENUESV2';
export const LOADING_RECO_PAGE = 'LOADING_RECO_PAGE';
export const LOAD_RECO_PAGE = 'LOAD_RECO_PAGE';
export const LOADING_RECO_VENUE_LIST = 'LOADING_RECO_VENUE_LIST';
export const LOAD_RECO_VENUE_LIST = 'LOAD_RECO_VENUE_LIST';

// shortlisted page
export const REJECTING_VENUE_BY_USER = 'REJECTING_VENUE_BY_USER';
export const PLANING_VISIT = 'PLANING_VISIT';
export const SHORTLISTED_VENUE_OBJECT = 'SHORTLISTED_VENUE_OBJECT';
export const VISIT_UPDATE_DATA = 'VISIT_UPDATE_DATA';
export const REQUEST_BOOKING_STATE = 'REQUEST_BOOKING_STATE';
export const REQUEST_BOOKING_SUCCESS_STATE = 'REQUEST_BOOKING_SUCCESS_STATE';
export const PLAN_VISIT_STATE = 'PLAN_VISIT_STATE';
export const PLANNED_VISIT_DETAILS = 'PLANNED_VISIT_DETAILS';
export const PLAN_VISIT_SUCCESS_STATE = 'PLAN_VISIT_SUCCESS_STATE';

export const PLAN_VISIT_EDIT_STATE = 'PLAN_VISIT_EDIT_STATE';
export const PLAN_VISIT_DONE = 'PLAN_VISIT_DONE';
export const LOAD_VENUE_ASSETS_DATA = 'LOAD_VENUE_ASSETS_DATA';
export const LOADING_VENUE_ASSETS_DATA = 'LOADING_VENUE_ASSETS_DATA';
export const UPDATING_MANAGER_DETAILS_SEEN = 'UPDATING_MANAGER_DETAILS_SEEN';
export const SENDING_MANAGER_DETAILS_SMS = 'SENDING_MANAGER_DETAILS_SMS';
export const UPDATE_ASSET_PACKAGE = 'UPDATE_ASSET_PACKAGE';
export const UPDATING_ASSET_PACKAGE = 'UPDATING_ASSET_PACKAGE';
export const EVENT_BROADCASTED_TO_AGENT = 'EVENT_BROADCASTED_TO_AGENT';
export const UPDATE_ASSET_VISIT = 'UPDATE_ASSET_VISIT';
export const ADD_ASSET_VISIT = 'ADD_ASSET_VISIT';
export const UPDATING_VENUE_ITEM = 'UPDATING_VENUE_ITEM';
export const FETCH_MAGIC_TOKEN = 'FETCH_MAGIC_TOKEN';

//visits page
// export const UPDATE_VISIT_SUCCESS = 'UPDATE_VISIT_SUCCESS';
// export const UPDATE_VISIT_FAILURE = 'UPDATE_VISIT_FAILURE';
export const UPDATE_VISIT = 'UPDATE_VISIT';
export const CONFIRMING_BOOKING = 'CONFIRMING_BOOKING';
export const PLANING_VISIT_SUCCESS = 'PLANING_VISIT_SUCCESS';

//booking page
export const BOOKING_REQUEST_SENT = 'BOOKING_REQUEST_SENT';

//customer feedback
export const UPDATING_FEEDBACK = 'UPDATING_FEEDBACK';
export const UPDATE_FEEDBACK = 'UPDATE_FEEDBACK';

export const SET_EVENT_ID = 'SET_EVENT_ID';
export const SUBMITTING_LEAD_FORM = 'SUBMITTING_LEAD_FORM';
export const SUBMITTING_SLIDER_FORM = 'SUBMITTING_SLIDER_FORM';

export const PLAN_VENUE_TOUR = 'PLAN_VENUE_TOUR';
export const IS_PLANNING_VENUE_TOUR = 'IS_PLANNING_VENUE_TOUR';
export const FETCH_HEAVY_DATE = 'FETCH_HEAVY_DATE';
export const FETCH_BOOKING_VISIT_COUNT_VISIBLE = 'FETCH_BOOKING_VISIT_COUNT_VISIBLE';
export const EVENTS_COUNT = 'EVENTS_COUNT'
export const SCHEDULE_CALL_MODAL_STATE = 'SCHEDULE_CALL_MODAL_STATE'
export const FETCH_MONTHLY_WINNER = 'FETCH_MONTHLY_WINNER'
export const FETCH_LEADERBOARD_DATA = 'FETCH_LEADERBOARD_DATA'
export const GET_REVIEW_TICKTES = 'GET_REVIEW_TICKTES'
export const FETCH_DATA_LOADING_STATE = 'FETCH_DATA_LOADING_STATE'
export const TICKET_LOADING_STATE = 'TICKET_LOADING_STATE'

export function fetchHeavyDateBasedOnEvent(input) {
    return async (dispatch) => {
        let res = await eventCallApi(`v1/heavyDates/get-date`, 'POST', {
            ...input,
        });
        if (res.status == 'Success') {
            dispatch(setHeavyDate(res.data.heavyDate));
        }
    };
}


export function setScheduleCallModalState(val){
    return {
        type : SCHEDULE_CALL_MODAL_STATE,
        is_schedule_call_modal_visible:val
    }
}

export function setHeavyDate(date) {
    return {
        type: FETCH_HEAVY_DATE,
        date: date,
    };
}



export function fetchingCurrentEventPage(page) {
    return {
        type: FETCH_EVENTS_FOR_PAGE,
        isLoading: true,
        currentEventPage: page,
    };
}

export function sendEventsFetchSuccessResponse(data) {
    return {
        type: FETCH_EVENTS_SUCCESS,
        isLoading: false,
        list: data.events,
        listCount: Math.ceil(data.totalCount / 12),
    };
}

export function sendEventsFetchFailedResponse() {
    return {
        type: FETCH_EVENTS_FAILURE,
        isLoading: false,
    };
}

export function recommendeVenuesV1(query) {
    return (dispatch) => {
        let model = [];
        let pageNum = 1;
        let pageSize = 10;
        if (query) {
            async.parallel(
                [
                    (cb) => {
                        fetchReccomendedVenues({query, pageNum, pageSize}, (err, list) => {
                            if (list) {
                                model.list1 = list ? list : [];
                                model.list1 = model?.list1?.map((item) => {
                                    item.algo = 'V1';
                                    return item;
                                });
                                return cb();
                            } else {
                                return cb(err);
                            }
                        });
                    },
                ],
                (err) => {
                    if (err) {
                        console.log('err in com', err);
                    } else {
                        let combinedList = model.list1;
                        let uniqueList = _.uniqBy(combinedList, 'vm_id');
                        dispatch({
                            type: FETCH_RECOMMENDED_VENUESV1,
                            recoListCombinedV1: uniqueList,
                        });
                    }
                }
            );
        }
    };
}

export function recommendeVenuesV2(query) {
    return (dispatch) => {
        let model = [];
        let pageNum = 1;
        let pageSize = 10;
        if (query) {
            async.parallel(
                [
                    (cb) => {
                        fetchReccomendedVenuesByTags({query, pageNum, pageSize}, (err, list) => {
                            if (list) {
                                model.list2 = list ? list : [];
                                model.list2 = model?.list2?.map((item) => {
                                    item.algo = 'V2';
                                    return item;
                                });
                                return cb();
                            } else {
                                return cb(err);
                            }
                        });
                    },
                ],
                (err) => {
                    if (err) {
                        console.log('err in com', err);
                    } else {
                        let combinedList = model.list2;
                        let uniqueList = _.uniqBy(combinedList, 'vm_id');
                        dispatch({
                            type: FETCH_RECOMMENDED_VENUESV2,
                            recoListCombinedV2: uniqueList,
                        });
                    }
                }
            );
        }
    };
}

export function fetchReccomendedVenues({query, pageNum, pageSize}, next) {
    venueCallApi(`venues/recommended-venues`, 'post', {
        event: query,
        pageNum: pageNum,
        pageSize: pageSize,
    })
        .then((res) => {
            if (res.status === 'Success') {
                // todo check the api 
                return next(null, []);
            } else {
                return next(null, []);
            }
        })
        .catch((e) => {
            console.log('err rec', e);
            return next(e);
        });
}

export function fetchReccomendedVenuesByTags({query, pageNum, pageSize}, next) {
    venueCallApi(`venues/tags/recommended-venue`, 'post', {
        event: query,
        pageNum: pageNum,
        pageSize: pageSize,
    })
        .then((res) => {
            if (res.status === 'Success') {
                return next(null, res.data.venues);
            } else {
                return next(null, []);
            }
        })
        .catch((e) => {
            return next(e);
        });
}

export function fetchEvents(userid, page) {
    return (dispatch) => {
        dispatch(fetchingCurrentEventPage(page));
        return eventCallApi(`customer/dashboard/user/${userid}/customer-events`, 'post', {
            pageNum: page,
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(sendEventsFetchSuccessResponse(res.data));
            } else {
                dispatch(sendEventsFetchFailedResponse());
            }
        });
    };
}

export function fetchingCurrentBookingPage(page) {
    return {
        type: FETCH_BOOKINGS_FOR_PAGE,
        isLoading: true,
        currentBookingPage: page,
    };
}

export function sendBookingsFetchSuccessResponse(data) {
    return {
        type: FETCH_BOOKING_SUCCESS,
        isLoading: false,
        bookings: data.bookings,
        bookingsCount: Math.ceil(data.totalCount / 12),
    };
}

export function sendBookingsFetchFailedResponse() {
    return {
        type: FETCH_BOOKING_FAILURE,
        isLoading: false,
    };
}

export function fetchBookings(userid, page) {
    return (dispatch) => {
        dispatch(fetchingCurrentBookingPage(page));
        return callApi(`profile/${userid}/bookings`, 'post', {
            pageNum: page,
            pageSize: 12,
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(sendBookingsFetchSuccessResponse(res.data));
            } else {
                let data = {
                    bookings: [],
                    totalCount: 0,
                };
                dispatch(sendBookingsFetchSuccessResponse(data));
                userNotify('Booking Failed,Please try again later.', 'error');
            }
        });
    };
}

export function updateBaseParamsState(val) {
    return {
        type: UPDATE_BASE_PARAMS_STATE,
        isLoadingBaseParams: !!val,
    };
}

export function updateLocationParamsState(val) {
    return {
        type: UPDATE_BASE_PARAMS_STATE,
        isLoadingLocationParams: !!val,
    };
}

export function fetchBasicParameters(city) {
    return (dispatch) => {
        dispatch(updateBaseParamsState(true));
        return eventCallApi(`customer/dashboard/user/${city}/base-filters`, 'GET').then((res) => {
            if (res.status === 'Success') {
                dispatch(loadEventBaseParams(res.data));
            } else {
                // userNotify('Failed to load event parameters, please try again', 'error');
            }
        });
    };
}

export function fetchLocationParameters(city) {
    return (dispatch) => {
        dispatch(updateLocationParamsState(true));
        return eventCallApi(`customer/dashboard/user/${city}/subareas`, 'GET').then((res) => {
            if (res.status === 'Success') {
                dispatch(loadEventLocationParams(res.data.subareas));
            } else {
                // userNotify('Failed to load location parameters, please try again', 'error');
            }
        });
    };
}

export function savingEventInfo(val) {
    return {
        type: UPDATING_EVENT,
        isSavingEventInfo: !!val,
    };
}

export function savedEventInfo(event) {
    return {
        type: UPDATE_EVENT,
        isSavingEventInfo: false,
        event: event,
    };
}

export function fetchingEvent() {
    return {
        type: FETCHING_EVENT,
        isFetchingEvent: true,
    };
}

export function fetchEvent(id) {
    return (dispatch) => {
        dispatch(fetchingEvent());
        return eventCallApi(`customer/dashboard/user/${id}/customer-event`, 'GET').then((res) => {
            if (res.status === 'Success') {
                dispatch(loadEvent(res.data.event));
            } else {
                // userNotify('Failed to load event info, please try again', 'error');
            }
        });
    };
}

export function fetchingEventBundle() {
    return {
        type: FETCHING_BUNDLE,
        isFetchingBundle: true,
    };
}

export function fetchEventPopulatedBundle(id) {
    return (dispatch) => {
        dispatch(fetchingEventBundle());
        return eventCallApi(`customer/dashboard/user/bundle/${id}/populated`, 'get').then((res) => {
            if (res.status === 'Success') {
                dispatch(loadBundle(res.data.bundle));
            }
        });
    };
}

export function toggleLoaderForEventPlan(val) {
    return {
        type: SUBMITTING_LEAD_FORM,
        isPlanningEvent: !!val,
    };
}

export function fetchMagicToken(token) {
    return {
        type: FETCH_MAGIC_TOKEN,
        magicToken: token,
    };
}

export function loadEvent(event, isPlanningEvent) {
    return {
        type: FETCH_EVENT,
        isFetchingEvent: false,
        isPlanningEvent: !!isPlanningEvent,
        event: event,
    };
}

export function loadBundle(bundle) {
    return {
        type: FETCH_BUNDLE,
        isFetchingBundle: false,
        bundle: bundle,
    };
}

export function fetchEventAndBundle(id) {
    return (dispatch) => {
        return eventCallApi(`customer/dashboard/user/${id}/customer-event`, 'GET').then((res) => {
            if (res.status === 'Success') {
                dispatch(loadEvent(res.data.event));
                if (res.data && res.data.event && res.data.event.bundleId) {
                    dispatch(fetchEventPopulatedBundle(res.data.event.bundleId));
                    dispatch(savedEventInfo(res.data.event));
                }
            } else {
                // userNotify('Failed to load event info, please try again', 'error');
            }
        });
    };
}

export function reRunFeaturedProcess(eventId) {
    return (dispatch) => {
        return eventCallApi(`v3/dashboard/user/event/${eventId}/featured-process`, 'POST');
    };
}

export function updateEventFromForm(id, event, formMode) {
    return (dispatch) => {
        return eventCallApi(`customer/dashboard/user/${id}/update-customer-event`, 'POST', {
            event: event,
        })
            .then((res) => {
                if (res.status === 'Success') {
                    dispatch(savedEventInfo(res.data.event));
                    dispatch(reRunFeaturedProcess(res.data?.event?.eventId));
                    let redirect_url = null;

                    redirect_url = makeRedirectionUrl(res.data.event);
                    dispatch(setEventRedirectionUrl(redirect_url));
                }
            })
            .catch((err) => {
                console.log(err);
                dispatch(savingEventInfo(false));
            });
    };
}

export function updateEvent(id, event) {
    return (dispatch) => {
        dispatch(savingEventInfo(true));
        return eventCallApi(`customer/dashboard/user/${id}/update-customer-event`, 'POST', {
            event: event,
        })
            .then((res) => {
                if (res.status === 'Success') {
                    dispatch(savedEventInfo(res.data.event));
                    dispatch(savingEventInfo(false));
                    userNotify('Details Updated', 'success');
                }
            })
            .catch((err) => {
                dispatch(savingEventInfo(false));
                userNotify('Failed to update event, please try again', 'error');
            });
    };
}

export function setRecoVenueCount(count) {
    return {
        type: UPDATE_RECO_COUNT,
        recoVenueCount: count,
    };
}

export function fetchRecoVenueCount(filters, id) {
    return (dispatch) => {
        return eventCallApi(`customer/dashboard/${id}/match-search-count`, 'POST', {
            data: filters,
        })
            .then((res) => {
                if (res.status === 'Success') {
                    dispatch(setRecoVenueCount(res.data.venueCount));
                }
            })
            .catch((err) => {
            });
    };
}

export function shortlistVenue(venueid, contactid, eventid, bundleid) {
    return (dispatch) => {
        dispatch(fetchingEventBundle());
        return eventCallApi(`customer/dashboard/user/bundle/${bundleid}/venue/add`, 'POST', {
            venueid: venueid,
            venuecontact: contactid,
            eventid: eventid,
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(loadBundle(res.data.bundle));
                userNotify('Venue shortlisted', 'success');
            }
        });
    };
}

export function shortlistVenueOnVenuePage(venueid, contactid, eventid, bundleid) {
    return (dispatch) => {
        dispatch(fetchingEventBundle());
        dispatch(showShortlistingVenuePageLoader(true));
        return eventCallApi(`customer/dashboard/user/bundle/${bundleid}/venue/add`, 'POST', {
            venueid: venueid,
            venuecontact: contactid,
            eventid: eventid,
        }).then((res) => {
            dispatch(showShortlistingVenuePageLoader(false));
            if (res.status === 'Success') {
                dispatch(loadBundle(res.data.bundle));
                userNotify('Venue shortlisted', 'success');
            }
        });
    };
}

export function shortlistVenueOnSearchPage(venueid, contactid, eventid, bundleid) {
    return (dispatch) => {
        dispatch(fetchingEventBundle());
        dispatch(showShortlistingVenueSearchPageLoader(venueid, true));
        return eventCallApi(`customer/dashboard/user/bundle/${bundleid}/venue/add`, 'POST', {
            venueid: venueid,
            venuecontact: contactid,
            eventid: eventid,
        }).then((res) => {
            dispatch(showShortlistingVenueSearchPageLoader(venueid, false));
            // dispatch(shortlistingVenueLoader(true))
            if (res.status === 'Success') {
                dispatch(loadBundle(res.data.bundle));
                userNotify('Venue Shortlisted', 'success');
            }
        });
    };
}

export function shortlistVenueForPlanVisit(venueid, eventid, bundleid) {
    return (dispatch) => {
        dispatch(fetchingEventBundle());
        return eventCallApi(`customer/dashboard/user/bundle/${bundleid}/venue/add`, 'POST', {
            venueid: venueid,
            eventid: eventid,
        }).then((res) => {
            if (res.status == 'Success') {
                dispatch(loadBundle(res.data.bundle));
            }
        });
    };
}

export function updatingItemInVenueList(venueId, keyName, value) {
    return {
        type: UPDATING_VENUE_ITEM,
        venueId: venueId,
        keyName: keyName,
        value: value,
    };
}

export function removeShortlistedVenue(venueid, bundleid, userRejectReason, bundleId) {
    return (dispatch) => {
        dispatch(fetchingEventBundle());
        dispatch(rejectingVenue(true));
        return eventCallApi(
            `customer/dashboard/user/bundle/${bundleid}/venue/${venueid}/reject`,
            'POST',
            {
                venueid: venueid,
                userRejectReason: userRejectReason ? userRejectReason : '',
            }
        )
            .then((res) => {
                dispatch(rejectingVenue(false));
                if (res.status === 'Success') {
                    dispatch(loadBundle(res.data.bundle));
                    dispatch(fetchEventPopulatedBundle(bundleId));
                    userNotify('Venue removed', 'success');
                }
            })
            .catch((err) => {
                dispatch(rejectingVenue(false));
                userNotify('Please try again', 'error');
            });
    };
}

export function removeShortlistedVenueOnVenuePage(venueid, bundleid) {
    return (dispatch) => {
        dispatch(fetchingEventBundle());
        dispatch(showShortlistingVenuePageLoader(true));
        return eventCallApi(
            `customer/dashboard/user/bundle/${bundleid}/venue/${venueid}/reject`,
            'POST',
            {
                venueid: venueid,
            }
        ).then((res) => {
            dispatch(showShortlistingVenuePageLoader(false));
            if (res.status === 'Success') {
                dispatch(loadBundle(res.data.bundle));
                userNotify('Venue removed', 'success');
            }
        });
    };
}

export function removeShortlistedVenueOnSearchPage(venueid, bundleid) {
    return (dispatch) => {
        dispatch(showShortlistingVenueSearchPageLoader(venueid, true));
        dispatch(fetchingEventBundle());
        return eventCallApi(
            `customer/dashboard/user/bundle/${bundleid}/venue/${venueid}/reject`,
            'POST',
            {
                venueid: venueid,
            }
        ).then((res) => {
            dispatch(showShortlistingVenueSearchPageLoader(venueid, false));
            if (res.status === 'Success') {
                dispatch(loadBundle(res.data.bundle));
                userNotify('Venue Removed', 'success');
            }
        });
    };
}

export function loadEventBaseParams(params) {
    return {
        type: FETCH_BASE_PARAMS,
        isLoadingBaseParams: false,
        packages: params.packages,
        occasions: params.occasions,
        venuetypes: params.venuetypes,
        cities: params.cities,
    };
}

export function loadEventLocationParams(locations) {
    return {
        type: FETCH_LOCATION_PARAMS,
        isLoadingLocationParams: false,
        locations: locations,
    };
}

export function fetchingRecoVenueList(val) {
    return {
        type: LOADING_RECO_VENUE_LIST,
        isLoadingVenueList: !!val,
    };
}

export function loadRecoVenueList(venues, totalCount) {
    return {
        type: LOAD_RECO_VENUE_LIST,
        isLoadingVenueList: false,
        venues: venues,
        recoVenueCount: totalCount,
    };
}

function updateAgentDetails(agentDetails) {
    return {
        type: 'AGENT_DETAILS',
        payload: agentDetails,
    };
}

export function calculateScore(user_price, venue_price, venue_location, user_location) {
    let price = parseInt(user_price) - parseInt(venue_price);
    let distance = distanceFromLatLong(venue_location, user_location);
    let distanceScore, priceScore;
    if (distance < 1.5) {
        distanceScore = 50;
    } else {
        distanceScore = (1 - parseFloat(distance) / 10) * 50;
    }
    priceScore = (1 - parseFloat(price) / parseFloat(user_price)) * 50;
    return parseInt(distanceScore + priceScore);
}

export function sortByKey(array, key) {
    return array.sort(function (a, b) {
        let x = a[key];
        let y = b[key];
        return x < y ? 1 : x > y ? -1 : 0;
    });
}

export function distanceFromLatLong(obj1, obj2) {
    let lat1 = obj1.lat;
    let lon1 = obj1.long;
    let lat2 = obj2.latitude;
    let lon2 = obj2.longitude;
    const p = 0.017453292519943295; // Math.PI / 180
    const c = Math.cos;
    let a =
        0.5 -
        c((lat2 - lat1) * p) / 2 +
        (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2;
    return Math.round(1274200 * Math.asin(Math.sqrt(a))) / 100; // 2 * R; R = 6371 km
}

export function fetchRecoVenueList(eventId, query, budget_end, location) {
    return (dispatch) => {
        dispatch(fetchingRecoVenueList(true));
        return eventCallApi(`customer/dashboard/${eventId}/match-search`, 'POST', {
            data: query,
        })
            .then((res) => {
                if (res.status === 'Success') {
                    if (res.data && res.data.totalCount > 0) {
                        if (res.data.venues && res.data.venues.length > 0) {
                            let newVenues = res.data.venues.map((item) => {
                                if (location && item.loc && budget_end) {
                                    item.score = calculateScore(
                                        budget_end,
                                        item.veg_min,
                                        item.loc,
                                        location
                                    );
                                    return item;
                                } else {
                                    return item;
                                }
                            });
                            newVenues = sortByKey(newVenues, 'score');
                            dispatch(loadRecoVenueList(newVenues, res.data.totalCount));
                        }
                    }
                }
            })
            .catch((err) => {
                dispatch(fetchingRecoVenueList(false));
            });
    };
}

export function showCreatingVisit(val) {
    return {
        type: PLANING_VISIT,
        isCreatingVisit: !!val,
    };
}

export function visitSuccess(val) {
    return {
        type: PLANING_VISIT_SUCCESS,
        isPlanVisitSuccess: !!val,
    };
}

export function rejectingVenue(val) {
    return {
        type: REJECTING_VENUE_BY_USER,
        isRejectingVenue: !!val,
    };
}

export function quotescallme(eventId, agentId) {
    return () => {
        return eventCallApi(
            `v3/dashboard/event/${eventId}/agent/${agentId}/change-priority`,
            'POST',
            {}
        )
            .then((res) => {
                if (res.status === 'Success') {
                    userNotify('you will receive a call in sometime!', 'success');
                } else {
                    show(res.data.message ? res.data.message : 'Failed, try again', 'error');
                }
            })
            .catch((err) => {
                userNotify('Failed, try again', 'error');
            });
    };
}


function visitScheduledDetails() {


}

export function planVisit(eventId, eventBundleId, venueId, visit, isShortlisted, hideSuccessModal) {
    return async (dispatch) => {
        try {
            if (!isShortlisted) {
                await dispatch(shortlistVenueForPlanVisit(venueId, eventId, eventBundleId));
            }
            dispatch(showCreatingVisit(true));
            const res = await eventCallApi(
                `v3/dashboard/event/${eventId}/venue/${venueId}/plan-visit`,
                'POST',
                {
                    visit: visit,
                }
            );

            if (res.status === 'Success') {
                dispatch(setPlanVisitState(false));
                if (!hideSuccessModal) {
                    dispatch(setPlanVisitSuccessState(true));
                }
                dispatch(fetchEventPopulatedBundle(eventBundleId));
                dispatch(showCreatingVisit(false));
                dispatch(addVisitInfoForUser(venueId, res.data.visit));
                userNotify('Visit Scheduled', 'success');
            } else {
                userNotify('Already Have A Scheduled Visit', 'error');
            }
        } catch (err) {
            dispatch(showCreatingVisit(false));
            dispatch(visitSuccess(false));
        }
    };
}
export function scheduleCallForCustomer(event_id, agent_id,scheduled_date) {
    return async (dispatch) => {
        try {
            const scheduleCall = {
                event_id,
                agent_id,
                scheduled_date
            }
            const res = await eventCallApi(
                `v1/schedulecalls/customer/schedule-call`,
                'POST',
                {
                    schedulecall: scheduleCall,
                }
            );

            if (res.status === 'Success') {
                
                    dispatch(setPlanVisitSuccessState(true));
                
                userNotify('Call Scheduled', 'success');
            } else {
                userNotify('Error While Scheduling Call', 'error');
            }
        } catch (err) {

        }
    };
}

export function updateVisit(id, visit, eventId, list) {
    return (dispatch) => {
        return eventCallApi(`v3/dashboard/visit/${id}/update-visit`, 'POST', {
            visit: visit,
        })
            .then((res) => {
                if (res.status === 'Success') {
                    if (list) {
                        dispatch(loadAllAssets(eventId, list));
                    }
                    userNotify('Visit Updated!', 'success');
                } else {
                    show(res.data.message ? res.data.message : 'Failed, try again', 'error');
                }
            })
            .catch((err) => {
                userNotify('Failed, try again', 'error');
            });
    };
}

export function fetchRawMagicToken(id) {
    return (dispatch) => {
        return eventCallApi(`customerevent/event/details?eventId=${id}`, 'POST', {}).then((res) => {
            if (res.status === 'Success') {
                if (res.data && res.data.magicToken) {
                    dispatch(fetchMagicToken(res.data.magicToken));
                }
            } else {
                // userNotify('Failed to load event info, please try again', 'error');
            }
        });
    };
}

export function confirmingBooking(val) {
    return {
        type: CONFIRMING_BOOKING,
        isConfirmingBooking: !!val,
    };
}

export function bookingRequestSent(val) {
    return {
        type: BOOKING_REQUEST_SENT,
        isBookingRequestSent: !!val,
    };
}

export function bookVenue(data) {
    return (dispatch) => {
        dispatch(confirmingBooking(true));
        dispatch(bookingRequestSent(true));
        return eventCallApi(
            `customer/dashboard/user/customer-event/${data.eventId}/convert`,
            'POST',
            {
                event: data,
            }
        )
            .then((res) => {
                dispatch(confirmingBooking(false));
                dispatch(bookingRequestSent(true));
                userNotify('Request Sent', 'success');
            })
            .catch((err) => {
                dispatch(confirmingBooking(false));
            });
    };
}

export function showLoaderForFeedbackSubmit() {
    return {
        type: UPDATING_FEEDBACK,
        isSaving: true,
    };
}

export function loadFeedback(feedback) {
    return {
        type: UPDATE_FEEDBACK,
        isSaving: false,
        feedback: feedback,
    };
}

export function setEventId(id) {
    return {
        type: SET_EVENT_ID,
        eventid: id,
    };
}

export function submitFeedbackForUser(id, feedback) {
    return (dispatch) => {
        dispatch(showLoaderForFeedbackSubmit());
        return callApi(`feedback/${id}/update`, 'POST', {
            feedback: feedback,
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(loadFeedback(res.data.feedback));
            }
        });
    };
}

export function fetchEventFeedback(id) {
    return (dispatch) => {
        return callApi(`feedback/${id}`, 'get').then((res) => {
            if (res.status === 'Success') {
                if (res.data.feedback) {
                    dispatch(loadFeedback(res.data.feedback));
                } else {
                    dispatch(loadFeedback({isError: true}));
                }
            }
        });
    };
}

export function submitEventForSearchSlider(event) {
    return (dispatch) => {
        dispatch(toggleLoaderForEventPlan(true));
        return eventCallApi(`customerevent/event/plan`, 'post', event).then((resp) => {
            dispatch(toggleLoaderForEventPlan(false));
            if (resp && resp.data && resp.data.eventid && resp.data.eventid !== '') {
                // setEventCookie(resp.data.event.event_date, resp.data.eventid);
                saveEventIdToStorage(resp.data.event.event_date, resp.data.eventid);
                dispatch(fetchEventAndBundle(resp.data.eventid));
                dispatch(setEventId(resp.data.eventid));
            } else {
                userNotify('Server did not respond, please try again', 'error');
            }
        });
    };
}

export function fetchingSimilarVenueList(val) {
    return {
        type: LOADING_RECO_VENUE_LIST,
        isLoadingVenueList: !!val,
    };
}

export function loadSimilarVenueList(venues, totalCount) {
    return {
        type: LOAD_RECO_VENUE_LIST,
        isLoadingVenueList: false,
        venues: venues,
        recoVenueCount: totalCount,
    };
}

export function fetchSimilarVenueList(eventId) {
    return (dispatch) => {
        dispatch(fetchingSimilarVenueList(true));
        return eventCallApi(`customer/dashboard/${eventId}/reco-match-search`, 'get').then(
            (res) => {
                if (res.status === 'Success') {
                    if (res.data && res.data.totalCount > 0) {
                        let location = {};
                        if (res.data.event && res.data.event.loc) {
                            location = {
                                latitude: res.data.event.loc.lat,
                                longitude: res.data.event.loc.long,
                            };
                        }
                        if (res.data.venues && res.data.venues.length > 0) {
                            let newVenues = res.data.venues.map((item) => {
                                if (!isEmpty(location) && item.loc && res.data.event) {
                                    item.score = calculateScore(
                                        res.data.event.budget_end,
                                        item.veg_min,
                                        item.loc,
                                        location
                                    );
                                    return item;
                                } else {
                                    return item;
                                }
                            });
                            newVenues = sortByKey(newVenues, 'score');
                            dispatch(loadSimilarVenueList(newVenues, res.data.totalCount));
                        }
                    }
                } else {
                    dispatch(fetchingSimilarVenueList(false));
                }
            }
        );
    };
}

export function fetchPreviousEventAndBundle(id) {
    return (dispatch) => {
        return eventCallApi(`customer/dashboard/user/${id}/past-event`, 'GET').then((res) => {
            if (res.status === 'Success') {
                if (res.data && res.data.event && res.data.event.bundleId) {
                    dispatch(loadEvent(res.data.event));
                    dispatch(fetchEventPopulatedBundle(res.data.event.bundleId));
                } else {
                    // removeEventId();
                    removeEventIdFromStorage();
                }
            }
        });
    };
}

export function showRecoPageLoading(val) {
    return {
        type: LOADING_RECO_PAGE,
        isLoadingRecoPage: !!val,
    };
}

export function loadRecoPage(data) {
    return {
        type: LOAD_RECO_PAGE,
        isLoadingRecoPage: false,
        isFetchingBundle: false,
        bundle: data.bundle,
        isLoadingBaseParams: false,
        packages: data.params.packages,
        occasions: data.params.occasions,
        venuetypes: data.params.venuetypes,
        cities: data.params.cities.map((item) => {
            return {label: item.name, value: item.name};
        }),
        isLoadingLocationParams: false,
        locations: data.locations,
    };
}

export function loadFullRecoPage(event) {
    return (dispatch) => {
        dispatch(showRecoPageLoading(true));
        let model = {};
        return async.series(
            [
                (cb) => {
                    eventCallApi(`customer/dashboard/user/${event.city}/subareas`, 'GET').then(
                        (res) => {
                            if (res.status === 'Success') {
                                model.locations = res.data.subareas;
                                return cb();
                            } else {
                                return cb();
                            }
                        }
                    );
                },
                (cb) => {
                    eventCallApi(`customer/dashboard/user/${event.city}/base-filters`, 'GET').then(
                        (res) => {
                            if (res.status === 'Success') {
                                model.params = res.data;
                                return cb();
                            } else {
                                return cb();
                            }
                        }
                    );
                },
                (cb) => {
                    eventCallApi(
                        `customer/dashboard/user/bundle/${event.bundleId}/populated`,
                        'get'
                    ).then((res) => {
                        if (res.status === 'Success') {
                            model.bundle = res.data.bundle;
                            return cb();
                        } else {
                            return cb();
                        }
                    });
                },
            ],
            (err) => {
                dispatch(loadRecoPage(model));
            }
        );
    };
}

export function showAssetsLoading(val) {
    return {
        type: LOADING_VENUE_ASSETS_DATA,
        isLoadingAssets: !!val,
    };
}

export function loadVenueAssets(assets) {
    return {
        type: LOAD_VENUE_ASSETS_DATA,
        isLoadingAssets: false,
        assets: assets,
    };
}

export function loadAllAssets(eventId, list) {
    return (dispatch) => {
        dispatch(showAssetsLoading(true));
        let model = {};
        return async.each(
            list,
            (venueId, callback) => {
                model[venueId] = {};
                eventCallApi(
                    `customer/dashboard/customer-event/${eventId}/venue/${venueId}/load-assets`,
                    'get'
                ).then((res) => {
                    if (res.status === 'Success') {
                        model[venueId].visits = res.data.visits;
                        model[venueId].subpackages = res.data.subpackages;
                        model[venueId].menus = res.data.menus;
                        return callback();
                    } else {
                        model[venueId].visits = [];
                        model[venueId].subpackages = [];
                        model[venueId].menus = [];
                        return callback();
                    }
                });
            },
            (err) => {
                dispatch(loadVenueAssets(model));
            }
        );
    };
}

export function updatingManagerDetailsSeen(venueId, loading, value) {
    return {
        type: UPDATING_MANAGER_DETAILS_SEEN,
        venueId: venueId,
        isLoading: loading,
        isContactSeenByUser: value,
    };
}

export function showbookingvisitBanner(val) {
    return {
        type: FETCH_BOOKING_VISIT_COUNT_VISIBLE,
        isBookingvisitcount: val,
    };
}


export function bookingvisitBanner(date, category) {

    return (dispatch) => {
        return eventCallApi(`v3/events/event-count-by-date`, 'POST', {
            date: date,
            category: category
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(showbookingvisitBanner(res.data));
                console.log(res.data);
            }
        })
    };
}


export function getNumberOfEventsOnDayForVenue(date, category) {
    return async (dispatch) => {
        try {
            const res = await eventCallApi(`v3/events/event-count-by-date`, 'POST', {
                date: date,
                category: category
            });

            if (res.status === 'Success') {
                dispatch(setEventCount(res.data?.count || 0));
                console.log(res.data);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };
}


export function handleSayaDateNudgesInfo(date, category) {
    return (dispatch) => {
        dispatch(checkIfIsSayaDate(date))
        dispatch(getNumberOfEventsOnDayForVenue(date, category))
    }

}

function setEventCount(count) {
    return {
        type: EVENTS_COUNT,
        eventsCount: count
    }
}


function getmonthlywinners(data) {
    return {
        type: FETCH_MONTHLY_WINNER,
        monthlywinners: data
    }
}


function getmonthlyleaderboarddata(data) {
    let customerObject = {};
    data?.leaderboardResult?.customers?.forEach(item => {
        customerObject[item._id] = item;
    });
    return {
        type: FETCH_LEADERBOARD_DATA,
        monthlyleaderboarddata: {
            list: data?.leaderboardResult?.list,
            customerObject
        }
    };
}
function getreviewtickets(data) {
    return {
        type: GET_REVIEW_TICKTES,
        tickets: data
    }
}


function getmonthlyleaderboarddataloading(status) {
    return {
        type: FETCH_DATA_LOADING_STATE,
        leaderdataloading: status
    }
}

function getmonthlyticketsloading(status) {
    return {
        type: TICKET_LOADING_STATE,
        ticketsloading: status
    }
}


export function updateManagerDetailsSeen(bundleId, venueId) {
    return (dispatch) => {
        dispatch(updatingManagerDetailsSeen(venueId, true, false));
        return eventCallApi(
            `customer/dashboard/user/bundle/${bundleId}/venue/${venueId}/update-details-seen`,
            'get'
        ).then((res) => {
            if (res.status === 'Success') {
                dispatch(updatingManagerDetailsSeen(venueId, false, true));
            } else {
                dispatch(updatingManagerDetailsSeen(venueId, false, false));
            }
        });
    };
}

export function sendingManagerDetailsSms(venueId, loading, value) {
    return {
        type: SENDING_MANAGER_DETAILS_SMS,
        venueId: venueId,
        isSendingSms: loading,
        isSmsSent: value,
    };
}

export function sendfetchDetails(agentId, loading) {
    return {
        type: FETCH_AGENT_DETAILS,
        agentId: agentId,
        isLoading: loading,
    };
}

export function sendManagerDetailsSms(eventId, venueId) {
    return (dispatch) => {
        dispatch(sendingManagerDetailsSms(venueId, true, false));
        return eventCallApi(
            `customer/dashboard/user/customer-event/${eventId}/venue/${venueId}/sms-manager-details`,
            'get'
        ).then((res) => {
            if (res.status === 'Success') {
                dispatch(sendingManagerDetailsSms(venueId, false, true));
            } else {
                dispatch(sendingManagerDetailsSms(venueId, false, false));
            }
        });
    };
}

export function fetchagentDetails(agentId) {
    return (dispatch) => {
        return callIdApi(`api/v3/agents/${agentId}`, 'get').then((res) => {
            if (res.status === 'Success') {
                dispatch(updateAgentDetails(res.data));
            } else {
                dispatch(sendingManagerDetailsSms(agentId, false, false));
            }
        });
    };
}

export function updatingPackageInfoForUser(venueId, packId, value) {
    return {
        type: UPDATING_ASSET_PACKAGE,
        venueId: venueId,
        packId: packId,
        isUpdating: value,
    };
}

export function isEventBroadcasted(value) {
    return {
        type: EVENT_BROADCASTED_TO_AGENT,
        isEventBroadcastedToAgent: value,
    };
}

export function updatePackageInfoForUser(venueId, packId, pack) {
    return {
        type: UPDATE_ASSET_PACKAGE,
        venueId: venueId,
        packId: packId,
        pack: pack,
    };
}

export function updatePackageInterestInfo(venueId, packId, isInterested) {
    return (dispatch) => {
        dispatch(updatingPackageInfoForUser(venueId, packId, true));
        return eventCallApi(
            `customer/dashboard/user/subpackage/${packId}/update-interest`,
            'post',
            {
                isInterested: isInterested,
            }
        ).then((res) => {
            if (res.status === 'Success') {
                dispatch(updatePackageInfoForUser(venueId, packId, res.data.subpackage));
            } else {
                userNotify('Failed To Update', 'danger');
                dispatch(updatingPackageInfoForUser(venueId, packId, false));
            }
        });
    };
}

export function broadcastEventToAgent(eventId, status) {
    return (dispatch) => {
        dispatch(isEventBroadcasted(false));
        return eventCallApi(`customerevent/event/${eventId}/broadcast-event-id`, 'post', {
            status,
        }).then((res) => {
            dispatch(isEventBroadcasted(true));
        });
    };
}

export function addVisitInfoForUser(venueId, visit) {
    return {
        type: ADD_ASSET_VISIT,
        venueId: venueId,
        visit: visit,
    };
}

export function setRequestBookingState(val) {
    return {
        type: REQUEST_BOOKING_STATE,
        isRequestBookingOverlayOpen: val,
    };
}

export function setRequestBookingSuccessState(val) {
    return {
        type: REQUEST_BOOKING_SUCCESS_STATE,
        isRequestBookingSuccessOverlayOpen: val,
    };
}

export function setPlanVisitState(val, data) {
    return {
        type: PLAN_VISIT_STATE,
        isPlanVisitOverlayOpen: val,
        visitUpdatedata: data,
    };
}

export function setPlanVisitDetails(details) {
    return {
        type: PLANNED_VISIT_DETAILS,
         visitDetails:details 
    };
}

export function setPlanVisitEditState(val, data) {
    return {
        type: PLAN_VISIT_EDIT_STATE,
        isPlanVisitEditOverlayOpen: val,
        visitUpdatedata: data,
    };
}

export function setPlanVisitSuccessState(val) {
    return {
        type: PLAN_VISIT_SUCCESS_STATE,
        isPlanVisitSuccessOverlayOpen: val,
    };
}

export function setVenueShortlistedData(data) {
    return {
        type: SHORTLISTED_VENUE_OBJECT,
        venueShortlisted: data,
    };
}

export function setVisitupdateVenues(data) {
    return {
        type: VISIT_UPDATE_DATA,
        visitUpdatedata: data,
    };
}

export function showLoaderForVenueTour(val) {
    return {
        type: IS_PLANNING_VENUE_TOUR,
        venueTourLoader: val,
    };
}

export const planVenueTour = (event, venue) => {
    return async (dispatch) => {
        try {
            dispatch(showLoaderForVenueTour(true));
            const res = await eventCallApi('v2/events/plan', 'post', event);
            if (res.status === 'Success') {
                saveEventIdToStorage(
                    new Date(
                        moment(new Date())
                            .add(7, 'days')
                            .toISOString()
                    ),
                    res.data.eventid
                );
                dispatch(loadEvent(res.data.event));
                dispatch(
                    sendFirstVerificationSms(res.data.eventid, res.data.event.contact_phone)
                ).then(() => {
                    dispatch(verifyOTPCode(res.data.eventid, '1111'));
                });
            }
        } catch (e) {
            dispatch(showLoaderForVenueTour(false));
        }
    };
};

export function fetchMonthlyContestWinners(filters) {
    return async (dispatch) => {
        try {
            const res = await eventCallApi(`v1/contest/monthly-winners`, 'POST' ,{filters: filters});

            if (res.status === 'Success') {
                dispatch(getmonthlywinners(res.data));
                console.log(res.data);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };
}


export function fetchMonthlyLeaderBoardData(filters, pageNum, pageSize) {
    
    return async (dispatch) => {
        try {
            dispatch(getmonthlyleaderboarddataloading(true));
            const res = await eventCallApi(`v1/contest/monthly-leaderboard`, 'POST', {
                pageNum: pageNum,
                pageSize: pageSize,
                filters: filters
            });
            if (res.status === 'Success') {
                dispatch(getmonthlyleaderboarddata(res.data));
                dispatch(getmonthlyleaderboarddataloading(false));
                console.log(res.data);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };
}


export function fetchCustomersReviewTickets(id) {
    return async (dispatch) => {
        try {
            dispatch(getmonthlyticketsloading(true))
            const res = await eventCallApi(`v1/contest/customer/${id}/tickets`, 'GET');

            if (res.status === 'Success') {
                dispatch(getreviewtickets(res.data));
            dispatch(getmonthlyticketsloading(false))
                console.log(res.data);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };
}
